import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface RoundedCloseIconProps extends IconProps {
  backgroundColor?: string;
}

const RoundedCloseIcon = ({ size, variant, className, backgroundColor }: RoundedCloseIconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="35" cy="35" r="35" fill={backgroundColor ?? '#EF4A3C'} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.3026 21.3026C22.2398 20.3653 23.7594 20.3653 24.6967 21.3026L34.9996 31.6055L45.3026 21.3026C46.2398 20.3653 47.7594 20.3653 48.6967 21.3026C49.6339 22.2398 49.6339 23.7594 48.6967 24.6967L38.3937 34.9996L48.6967 45.3026C49.6339 46.2398 49.6339 47.7594 48.6967 48.6967C47.7594 49.6339 46.2398 49.6339 45.3026 48.6967L34.9996 38.3937L24.6967 48.6967C23.7594 49.6339 22.2398 49.6339 21.3026 48.6967C20.3653 47.7594 20.3653 46.2398 21.3026 45.3026L31.6055 34.9996L21.3026 24.6967C20.3653 23.7594 20.3653 22.2398 21.3026 21.3026Z"
      fill="white"
    />
  </svg>
);
export default RoundedCloseIcon;
